export default "__VITE_ASSET__BveIc8rN__"